import { Outlet, useOutletContext } from "react-router-dom";

const PWSChildRootLayoutPage = () => {
  const { setShowBackButton, setHeader, setDisplayNotes, setModal } =
    useOutletContext();
  return (
    <Outlet
      context={{ setShowBackButton, setHeader, setDisplayNotes, setModal }}
    />
  );
};
export default PWSChildRootLayoutPage;
